import React, { Component } from "react";
import Countdown from "../components/CountDown";
import { View } from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import { translate } from "../locales/translate";

import ArButton from "../argon-ui/Button";
import GuestExpirePicker from "../components/GuestExpirePicker";
import ArTheme from "../argon-ui/Theme";
import * as Actions from "../actions/UserActions";
import { VStack } from "native-base";

class UpdateGuestExpireScreen extends Component {
  constructor(props) {
    super(props);
    let { userId } = this.props.navigation.state.params;
    let user = undefined;
    if (userId) {
      for (var i in this.props.reducer.guests) {
        let g = this.props.reducer.guests[i];
        if (g.id == userId) {
          user = g;
          break;
        }
      }
    }

    let expireSeconds = 0;
    if (user && user.expireDate) {
      var exp = new Date(user.expireDate);
      var now = new Date();

      var currentLocalDate = Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        now.getHours(),
        now.getMinutes(),
        now.getSeconds()
      );

      expireSeconds = (exp.getTime() - currentLocalDate) / 1000;
    }

    this.state = {
      user,
      expireUnit: "day",
      expireValue: 1,
      expireSeconds,
      accessToken: "",
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.UserList"),
  });

  componentDidMount() {
    this.setState({
      accessToken: this.props.appReducer?.currentServer.accessToken,
    });
  }
  render() {
    if (!this.state.user) {
      return <Text>not found</Text>;
    }
    return (
      <View style={{ flex: 1 }}>
        <View style={{ flex: 1 }}>
          <Text
            style={{ textAlign: "center", fontSize: 22, fontWeight: "bold" }}
          >
            {this.state.user.fullName}
          </Text>
          <Text style={{ textAlign: "center", fontSize: 16 }}>
            {this.state.user.phoneNumber}
          </Text>
          <Text
            style={{
              textAlign: "center",
              color: ArTheme.COLORS.MUTED,
            }}
          >
            {this.state.user.description}
          </Text>
          {this.state.expireSeconds > 0 && (
            <Countdown
              until={this.state.expireSeconds}
              style={{ marginVertical: 15, direction: "ltr" }}
              size={32}
              digitStyle={{ backgroundColor: "#FFFFFF00", paddingTop: 15 }}
              timeLabelStyle={{ color: ArTheme.COLORS.MUTED }}
              timeLabels={{
                d: translate("timer.days"),
                h: translate("timer.hours"),
                m: translate("timer.minutes"),
                s: translate("timer.seconds"),
              }}
              showSeparator
            />
          )}
        </View>
        <View style={{ flex: 1, paddingTop: 60 }}>
          <Text style={{ fontWeight: "bold", paddingVertical: 10 }}>
            {translate("user.resetGuestExpire")}
          </Text>
          <GuestExpirePicker
            expireValueIsValid={true}
            onValueChange={(txt) => {
              if (txt) {
                this.setState({
                  expireValue: Math.floor(Number(txt)),
                  expireValueIsValid: true,
                });
              } else {
                this.setState({
                  expireValueIsValid: false,
                });
              }
            }}
            onUnitChange={(unit) => {
              this.setState({
                expireUnit: unit,
              });
            }}
          />
        </View>

        <VStack space={2} style={{ marginVertical: 10 }}>
          <ArButton
            color="primary"
            style={{ width: "100%" }}
            onPress={() => {
              let { id } = this.state.user;
              let { expireUnit, expireValue, accessToken } = this.state;
              this.props.updateExpireDate(
                id,
                expireValue,
                expireUnit,
                accessToken
              );

              this.props.navigation.navigate("Users");
            }}
          >
            <Text style={{ color: "#FFF" }}>{translate("app.confirm")}</Text>
          </ArButton>

          <ArButton
            style={{ width: "100%" }}
            color="muted"
            onPress={this.props.navigation.goBack}
          >
            <Text style={{ color: "#FFF" }}>{translate("app.goBack")}</Text>
          </ArButton>
        </VStack>
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    reducer: state.UserReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateExpireDate: (userId, expireValue, expireUnit, accessToken) =>
      dispatch(
        Actions.UpdateExpireDate(userId, expireValue, expireUnit, accessToken)
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateGuestExpireScreen);
